import { useEffect, useRef, useState } from 'react';
import useSound from '@mrmartineau/use-sound';
import { ReactComponent as ShareSvg } from '../share-icon.svg';
import { getBaseCard, getCardVariant, humanCardName, VARIANT_MESSAGES } from '../utils/cards';
import { getDeckStats } from '../utils/storage';
import CardVariantOverlay from '../CardVariantOverlay';
import openingSxf from '../sounds/wash.mp3';
import openedSxf from '../sounds/magic.mp3';

export function VictoryModal({ isOpen, onClose, hrs, mins, secs, earnedCard, hasOpenedTodaysBoosterPack, isCopied, onCopy, onShare, onBoosterPackOpened, onOpenCollection, cardImageFolder = 'smallcards' }) {
  const { unique, total } = getDeckStats();
  const earnedVariant = earnedCard ? getCardVariant(earnedCard) : null;
  const [isOpeningBoosterPack, setIsOpeningBoosterPack] = useState(false);
  const openingTimeoutRef = useRef(null);
  const [playOpeningSound] = useSound(openingSxf);
  const [playOpenedSound] = useSound(openedSxf);

  useEffect(() => {
    return () => {
      if (openingTimeoutRef.current) {
        clearTimeout(openingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (hasOpenedTodaysBoosterPack) {
      setIsOpeningBoosterPack(false);
    }
  }, [hasOpenedTodaysBoosterPack]);

  const handleOpenBoosterPack = () => {
    if (isOpeningBoosterPack || hasOpenedTodaysBoosterPack) return;

    setIsOpeningBoosterPack(true);
    playOpeningSound();
    openingTimeoutRef.current = setTimeout(() => {
      playOpenedSound();
      setIsOpeningBoosterPack(false);
      onBoosterPackOpened?.();
      openingTimeoutRef.current = null;
    }, 1500);
  };

  return (
    <>
    <div className={`modal victory-modal ${isOpen ? 'open' : 'closed'}`}>
      <div className='modal-overlay' onClick={onClose}></div>
      <div className='modal-content'>
        <h2>Victory!</h2>
        <p>
          Well done, you beat Poqueta in <strong className='hint found' style={{ display: 'inline-block', margin: '4px 2px' }}>
            {hrs > 0 && <>{hrs} hr{hrs > 1 ? 's' : ''} </>}
            {mins > 0 && <>{mins} min{mins > 1 ? 's' : ''} </>}
            {secs > 0 && <>{secs} second{secs > 1 ? 's' : ''} </>}
          </strong>
        </p>
        {earnedCard && (
          <div className='winnings-box'>            
            {hasOpenedTodaysBoosterPack ? (
              <p>
                You won the <strong>{humanCardName(earnedCard)}!</strong>
                <br />
                {/* rare instance there's a card variant message */}
                { VARIANT_MESSAGES[earnedVariant] && (
                  <>
                  <i><b><small>{VARIANT_MESSAGES[earnedVariant]}</small></b></i>
                  <br />
                  </>
                )}
                <small>
                  You now have {unique} unique card{unique !== 1 ? 's' : ''}{' '}
                  <span style={{ display: 'inline-block' }}>{total > unique ? `+ ${total - unique} duplicates` : ''}</span>
                </small>
                <br />
                <button onClick={onOpenCollection}>View card collection</button>
              </p>
            ) : (
              <p>
                You earnt a <strong>Booster Pack!</strong>
                <br />
                <small>
                  Open it to discover your reward.
                  <span style={{ display: 'inline-block' }}>&nbsp;</span>
                </small>
                <br />
                <button onClick={handleOpenBoosterPack} disabled={isOpeningBoosterPack}>
                  {isOpeningBoosterPack ? 'Opening...' : 'Open Booster Pack'}
                </button>
              </p>
            )}

            <div className='fancy-card-stack'>
              {hasOpenedTodaysBoosterPack ? (
                <>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>

                  <div className={`card ${earnedVariant ?? ''}`}>
                    {earnedVariant ? (
                      <CardVariantOverlay
                        variant={earnedVariant}
                        imageSrc={`./assets/${cardImageFolder}/${getBaseCard(earnedCard).toLowerCase()}.png`}
                        alt={earnedCard}
                        title={humanCardName(earnedCard)}
                        className='front'
                      />
                    ) : (
                      <img alt={earnedCard} className='front' src={`./assets/${cardImageFolder}/${getBaseCard(earnedCard).toLowerCase()}.png`} />
                    )}
                  </div>
                </>
              ) : (
                <div className={`card booster ${isOpeningBoosterPack ? 'opening' : ''}`} onClick={handleOpenBoosterPack}>
                  {/* <img alt='' className='front' src='./assets/misc/booster.png' /> */}
                  <CardVariantOverlay
                    variant='booster'
                    imageSrc='./assets/misc/booster.png'
                    alt='Booster Pack'
                    title='Booster Pack'
                    className='front'
                  />
                </div>
              )}


            </div>
          </div>
        )}
        <div className='modal-buttons'>
          <button className='mobile-only' onClick={onShare}>
            <ShareSvg />
          </button>
          <button onClick={onCopy} className={`big ${isCopied ? 'copied' : ''}`}>
            {isCopied ? 'Score copied' : 'Copy Score'}
          </button>
          <button className='big' onClick={onClose}>Admire Puzzle</button>
        </div>
        <p><small>Poqueta will return <span style={{ display: 'inline-block' }}>with a new puzzle tomorrow.</span></small></p>
      </div>
    </div>
    { isOpeningBoosterPack && <div className='booster-opening-overlay'></div> }
    </>
  );
}
